

export const spaceFormValidation = (value) => {
    let error = {};
    
    if(!value.spaceTitle){
        error.spaceTitle = "Space Title name is empty";
    }

    if(!value.organizationName){
        error.organizationName = "Organization Name name is empty";
    }

    if(!value.description){
        error.description = "Description code is empty";
    }

    if(!value.country){
        error.country = "Country code is empty";
    }

    return error;
}

export const dailyPricingOptionValidation = (days, selectedDays) => {
  if (
    selectedDays.length === 0 ||
    (selectedDays.length === 1 && selectedDays.some(item=> item === "Public Holiday"))
  )
    return days;

  if (selectedDays.some(item=> item === "Daily")) 
    days = days.filter((opt) => {
      if (opt === "Daily" || opt === "Public Holiday") {
        return opt;
      }
    });

  if (selectedDays.some(item=> item === "Weekdays") )
    days = days.filter((opt) => {
      if (opt !== "Monday" && opt !== "Tuesday" && opt !== "Wednesday" &&  opt !=="Thursday" &&  opt !=="Friday") {
        return opt;
      }
    });

  if (selectedDays.some(item=> item === "Weekends") )
    days = days.filter((opt) => {
      if (opt !== "Sunday" && opt !== "Saturday") {
        return opt;
      }
    });

  if (
    selectedDays.some(item=> item === "Monday")||
    selectedDays.some(item=> item === "Tuesday")||
    selectedDays.some(item=> item === "Wednesday")||
    selectedDays.some(item=> item === "Thursday")||
    selectedDays.some(item=> item === "Friday")
  ) {
    days = days.filter((opt) => {
      if (opt != "Daily" && opt != "Weekdays") {
        return opt;
      }
    });
  }

  if (
    selectedDays.some(item=> item === "Saturday")||
    selectedDays.some(item=> item === "Sunday")
  ) {
    days = days.filter((opt) => {
      if (opt != "Daily" && opt != "Weekends") {
        return opt;
      }
    });
  }

  return days;
};

export const PricingOptionValidation = (options, selectedOptions) => {
    if (selectedOptions?.length === 0){
        return options;
    }else if (selectedOptions?.some(i => options?.find( opt => opt?.id === i)?.name == 'Hourly')){
        return options?.filter(opt => opt?.name !== 'Block');
    }else if (selectedOptions?.some(i => options?.find( opt => opt?.id === i)?.name == 'Block')){
        return options?.filter(opt => opt?.name !== 'Hourly');
    }else {
        return options;
    }
};

export const addPackageCount = (packages, setCount) => {
  const packageCountList = packages?.map((pkg, index) => index+1);
  setCount(packageCountList || [1]);
}

export const addDiscountCount = (discounts, setCount) => {
    const discountCountList = discounts?.map((discount, index) => index+1);
    setCount(discountCountList || [1]);
}
